import { Link, Typography } from "@mui/material";
import { attributesToProps, DOMNode, domToReact } from "html-react-parser";

import { styles } from "./AlertBanner.styles";

export const replaceDOMNode = (node: DOMNode) => {
  if (node.type !== "tag" || !("attribs" in node)) {
    return undefined;
  }

  const { attribs, name, children } = node;
  const props = attributesToProps(attribs);
  if (name === "a") {
    return (
      <Link {...props} css={[styles.link, styles.parsedDOMNode]}>
        {domToReact(children, ALERT_TEXT_PARSER_OPTIONS)}
      </Link>
    );
  }
  if (name === "p") {
    return (
      <Typography {...props} css={styles.parsedDOMNode}>
        {domToReact(children, ALERT_TEXT_PARSER_OPTIONS)}
      </Typography>
    );
  }
};

export const ALERT_TEXT_PARSER_OPTIONS = {
  replace: replaceDOMNode,
};
